<div class="fieldset-wrapper">
  <div
    *ngIf="imgQuestion?.QuestionImageAndMedia_1 != null"
    class="questionImageWrapper"
    [ngClass]="{ 'question-border': !isMobile }"
  >
    <app-question-image-and-media
      [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_1"
      [imageSize]="imgQuestion?.ImageSize"
      [isMobile]="isMobile"
    >
    </app-question-image-and-media>
  </div>
  <fieldset>
    <legend
      class="question-option-wrapper"
      [ngClass]="{ 'question-border': imgQuestion.QuestionImageAndMedia_1 == null && !isMobile }"
    >
      <span *ngIf="isDisplayQno" class="question-no"><strong>{{ imgQuestion.qno }}.</strong></span>
      <span
        [ngClass]="{
          'question-text': group?.isOverAllStyleApplied,
          'question-text-nb': !group?.isOverAllStyleApplied,
          'no-Qno': !isDisplayQno
        }"
        id="lbltitle_{{ imgQuestion?.UniqueNumber }}"
      >
        <span
          *ngIf="questions[0]?.piping"
          [innerHTML]="getPipingTitle(questions[0]?.group_no) | headerFooterHtml"
        ></span>
        <span *ngIf="!questions[0]?.piping" [innerHTML]="group?.gtitle | headerFooterHtml"></span>
        <span
          *ngIf="group?.QuestionTip"
          class="tooltip_icon"
          appTooltip
          [dataContext]="group?.QuestionTip"
          [IsButtonPanel]="false"
          [qid]="imgQuestion?.UniqueNumber"
          tabindex="0"
        ></span>
        <div
          *ngIf="
            imgQuestion?.hasMedia && imgQuestion?.MediaText != null && imgQuestion?.MediaText != ''
          "
          class="question-media-text"
        >
          <span>[{{ imgQuestion?.MediaText }}]</span>
        </div>
      </span>
    </legend>
    <div *ngIf="imgQuestion?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media
        [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_2"
        [imageSize]="imgQuestion?.ImageSize"
        [isMobile]="isMobile"
      >
      </app-question-image-and-media>
    </div>
    <div class="fieldset-wrapper-scroll-cont">
      <div class="fieldset-wrapper-scroll" style="overflow: visible">
        <div style="display: table; width: 100%" class="answerParent">
          <div class="answer-option-wrapper demo-box">
            <div *ngFor="let question of questions | callBack: getHiddenQuestions; let i = index">
              <!-- Drop Down -->
              <div
                [hidden]="question.isCQ && question.isCQHide"
                *ngIf="question.qtype == 'RW'"
                [ngClass]="{ 'demo-read-only': question.population_type == 3,
                  'disabled-question': isPostEditDisable(question)
                 }"
                class="demographics-wrapper {{ getDemoClass(question) }}"
                id="dv_{{ question?.UniqueNumber }}"
              >
                <app-drop-down
                  [JsonData]="GetQuestionsString(question)"
                  [isDisplayQno]="false"
                  [isMDD]="false"
                  [isNonSearchable]="false"
                  [isDisplaySubQno]="group?.ShowDemoSubQno && isDisplayQno"
                  [isDemographics]="true"
                  [isMandatoryUpfront]="isMandatoryUpfront"
                  [isOtherControl]="true"
                  [DropDown]="DropDown"
                  [dropDownlength]="dropDownlength"
                  (ChangeAnswersData)="UpdateQuestionsData($event)"
                >
                </app-drop-down>
              </div>
              <!-- Text Box -->
              <div
                [hidden]="question.isCQ && question.isCQHide"
                *ngIf="question.qtype == 'T'"
                class="demographics-wrapper {{ getDemoClass(question) }}"
                id="dv_{{ question?.UniqueNumber }}"
                style="position: static"
                [ngClass]="{
                  longTextBox:
                    question.DemographicFieldID == 91 || question.DemographicFieldID == 92,
                  'dv-email-question': question.qsubtype == 31,
                  'geo-code-container': question.qsubtype == 63,
                  'demo-read-only': question.population_type == 3,
                  'disabled-question': isPostEditDisable(question)
                }"
              >
                <app-text-box
                  [JsonData]="GetQuestionsString(question)"
                  [isDisplayQno]="false"
                  [isMTB]="false"
                  [isDisplaySubQno]="group?.ShowDemoSubQno && isDisplayQno"
                  [MonthArray]="MonthArray"
                  [isMobile]="isMobile"
                  [isDemographics]="true"
                  [isMandatoryUpfront]="isMandatoryUpfront"
                  [isOtherControl]="true"
                  (ChangeAnswersData)="UpdateQuestionsData($event)"
                  (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)"
                  (AnsChangecall)="AnsChangecall($event)"
                >
                </app-text-box>
              </div>
            </div>
            <ng-container *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)">
              <div class="ques-response-btn-div">
                <button
                  *ngIf="
                    !(
                      questions.length == 1 &&
                      questions[0].qtype == 'RW' &&
                      isAutoScroll && !isPreReadQn
                    ) &&
                    isNewParticipationButton &&
                    (isAnsChange || isPreReadQn)
                  "
                  type="button"
                  class="ques-response-btn"
                  (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
                  (click)="gotoNextQuestion(questions[0], $event.target)"
                >
                  {{ newParticipationBtnText }}
                </button>
              </div>
            </ng-container>
            <div *ngIf="isNgAfter">{{ ngOnChangesEventHandle() }}</div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
